export const giftColumns = [
    {title: '礼品规格', dataIndex: 'name'},
    {
        title: '礼品清单',
        dataIndex: 'gift_list',
        customRender: (text, record) => {
            let res = '';
            if(text) {
                try {
                    const list = JSON.parse(text);
                    res = list.map(item => `${item.name} × ${item.number}`).join(",");
                    record.giftList = res;
                } catch (e) {
                    console.error(e)
                }
            }
            return res;
        }
    },
    {title: '规格描述', dataIndex: 'describe'},
]
